import React from "react";

/**
 * What the asset actually did, as a move from the price the forecast started
 * from.
 *
 * The lists showed the closing price alone, which says nothing on its own: a
 * reader has to hold the baseline in their head to know whether $39.52 was a
 * rise or a fall. The forecast beside it is already stated as a move — "-6.5%
 * to +6.4%" — so this is the number that makes the two comparable at a glance,
 * and it is the same arithmetic the score is computed from.
 *
 * Measured from the settled baseline, not from the price the model reported
 * for itself. Those are deliberately different references and each belongs
 * where it is: a model's range is its claim about a move from where it thought
 * price was, while what the market did is a fact about the real open. Reading
 * the actual move from a model's own mistaken price would make the same close
 * a different percentage on every row of one question.
 *
 * Grey rather than green/red. The cell it sits in already spends colour on
 * right/wrong, and a second red/green axis in one cell invites reading "+1.2%"
 * as a verdict. The arrow carries the direction instead.
 */
const num = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const ActualChange = ({ row }) => {
  const base = num(row.current_price);
  const actual = num(row.actual_price);
  if (!base || actual === null) return null;

  const pct = ((actual - base) / base) * 100;
  const arrow = pct > 0 ? "ri-arrow-up-line" : pct < 0 ? "ri-arrow-down-line" : "ri-arrow-right-line";

  return (
    <span
      className="text-muted fs-12 d-block"
      title={`Closed at ${actual.toFixed(2)}, from ${base.toFixed(2)} when the forecast was made`}
    >
      <i className={`${arrow} align-bottom`} />
      {` ${pct >= 0 ? "+" : ""}${pct.toFixed(1)}%`}
    </span>
  );
};

export default ActualChange;
